// extracted by mini-css-extract-plugin
export default {"menu":"style_menu__RZsYZ","menuItem":"style_menuItem__5jjbH","menuItemChip":"style_menuItemChip__QV3Cx","menuItemActive":"style_menuItemActive__x6dXy"};